module.exports = __webpack_public_path__ + "static/media/franchise-purple-icon.e092d1b0.svg";